import { Link } from "react-router-dom";
import { Button } from "../components";

export default function NotFound() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <div className="text-6xl font-bold text-black dark:text-lz-concrete">
        404
      </div>
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-black dark:text-lz-concrete">
          Page Not Found
        </h1>
        <p className="text-xl mt-2 text-black dark:text-lz-concrete">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
      </div>
      <Link to="/">
        <Button>Return Home</Button>
      </Link>
    </div>
  );
}
